import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Drawer,
  Chip,
  IconButton,
  Tooltip,
} from "@mui/material";
import { getConversations } from "../../../services/message";
import ConversationDetail from "../../position/components/messages/ConversationDetail";
import ChatIcon from "@mui/icons-material/Chat";
import moment from "moment";
import { useLocation } from "react-router-dom";

function ActionRequiredMessagesWidget() {
  const [conversations, setConversations] = useState([]);
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const fetchData = () => {
    setLoading(true);
    // Filter logic: Open (0) or Snoozed (2).
    getConversations({
      where: {
        status: { inq: [0, 2] },
      },
      include: ["user", "position"],
      order: "lastUserMessageAt DESC",
      limit: 10,
    })
      .then((response) => {
        setConversations(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Deep linking handler
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const conversationIdParam = searchParams.get("conversationId");
    if (conversationIdParam) {
      const conversationId = parseInt(conversationIdParam, 10);
      if (!isNaN(conversationId)) {
        handleOpenConversation(conversationId);
      }
    }
  }, [location.search]);

  const handleOpenConversation = (id) => {
    setSelectedConversationId(id);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedConversationId(null);
    fetchData();
  };

  return (
    <>
      <Card sx={{ height: "100%" }}>
        <CardHeader title="Üzenetek / Teendők" />
        <CardContent sx={{ p: 0, height: 400, overflow: "auto" }}>
          {conversations.length === 0 && !loading && (
            <Typography sx={{ p: 2 }} color="text.secondary">
              Nincs új üzenet.
            </Typography>
          )}
          <List>
            {conversations.map((conv) => (
              <ListItem
                key={conv.id}
                button
                onClick={() => handleOpenConversation(conv.id)}
                secondaryAction={
                  <Tooltip title="Megnyitás">
                    <IconButton edge="end">
                      <ChatIcon />
                    </IconButton>
                  </Tooltip>
                }
              >
                <ListItemAvatar>
                  <Avatar>{conv.user?.firstName?.charAt(0) ?? "?"}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <React.Fragment>
                      <Typography component="span" variant="subtitle2">
                        {conv.user
                          ? `${conv.user.lastName} ${conv.user.firstName}`
                          : "Ismeretlen felhasználó"}
                      </Typography>
                      {conv.status === 2 && (
                        <Chip
                          label="Szundi"
                          size="small"
                          color="warning"
                          sx={{ ml: 1, height: 20, fontSize: "0.7rem" }}
                        />
                      )}
                    </React.Fragment>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {conv.position?.name} ({conv.position?.id})
                      </Typography>
                      {" - " +
                        moment(
                          conv?.messages?.[0]?.createdAt ?? Date.now()
                        ).fromNow()}
                    </React.Fragment>
                  }
                />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={handleCloseDrawer}
        PaperProps={{ sx: { width: "600px", maxWidth: "100%" } }}
      >
        {selectedConversationId && (
          <ConversationDetail
            conversationId={selectedConversationId}
            onClose={handleCloseDrawer}
          />
        )}
      </Drawer>
    </>
  );
}

export default ActionRequiredMessagesWidget;
